import React from 'react';
import {Spin} from 'antd';
import PropTypes from 'prop-types';
import './index.style.less';

/** Loader for main content area — does not cover admin header/sidebar. */
const AppLoader = ({message = 'Please wait…'}) => {
  return (
    <div className='app-loader' role='status' aria-live='polite' aria-busy='true'>
      <div className='app-loader__panel'>
        <Spin size='large' />
        {message ? <p className='app-loader__text'>{message}</p> : null}
      </div>
    </div>
  );
};

AppLoader.propTypes = {
  message: PropTypes.string,
};

export default AppLoader;
